import { Badge, type BadgeVariant } from '@omnitok/ui';
import type { LocalizationItemStatus, LocalizationRunStatus } from '../types/localization.types';

const labels: Record<LocalizationRunStatus | LocalizationItemStatus, string> = {
  queued: 'En cola',
  processing: 'Procesando',
  awaiting_selection: 'Esperando selección',
  awaiting_review: 'Esperando revisión',
  approved: 'Aprobado',
  queued_apply: 'Aplicación en cola',
  applying: 'Aplicando',
  completed: 'Completado',
  failed: 'Fallido',
  cancelled: 'Cancelado',
  pending: 'Pendiente',
  'selection-required': 'Requiere selección',
  'preview-generated': 'Preview generado',
  applied: 'Aplicado',
  'not-found': 'No encontrado',
  invalid: 'Inválido',
  'already-localized': 'Ya localizado',
};

const colors: Partial<Record<LocalizationRunStatus | LocalizationItemStatus, BadgeVariant>> = {
  processing: 'info',
  applying: 'info',
  awaiting_review: 'warning',
  awaiting_selection: 'warning',
  approved: 'success',
  completed: 'success',
  'preview-generated': 'success',
  'selection-required': 'warning',
  applied: 'success',
  failed: 'error',
  invalid: 'error',
  'not-found': 'error',
  cancelled: 'warning',
  'already-localized': 'warning',
};

export default function LocalizationStatusChip({
  status,
}: {
  status: LocalizationRunStatus | LocalizationItemStatus;
}) {
  return <Badge size="sm" pill variant={colors[status] ?? 'neutral'}>{labels[status]}</Badge>;
}
